import { fetch } from '@/shared/fetch';
import { IApproximateWaitingTimeResponse } from '@/shared/interfaces';
import { ConsultationTypeEnum } from '@/shared/enums';

export const fetchWaitingTime = async (
    consultationType: ConsultationTypeEnum,
) => {
    return await fetch<IApproximateWaitingTimeResponse>(
        `/api/consultations/video/waitingtime/v2?consultationType=${consultationType}`,
        'GET',
    );
};
